import React, { useState } from 'react';
import { Box } from '@material-ui/core';
import clsx from 'clsx';
import { CustomSwitch, ReskinningInputs } from '../../../../Components';
import useStyles from '../styles';

export default function AgentWalletConfigurationContent({ setState, state }) {
  const styles = useStyles();

  const handleChange = (field) => (event) => {
    const { value } = event.target;
    setState((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  return (
    <Box className={styles.agentWalletConfigurationContent}>
      <Box className={styles.Header}>
        <span className={styles.title}>Agent Wallet Configuration</span>
        <span className={styles.divider}></span>
      </Box>

      <ReskinningInputs
        labelValue='Standard call minutes cost'
        type='isnumber'
        withNumberPersantageFormat
        wrapperClasses={clsx(styles.wrapperInput, styles.inputWithMargin)}
        endAdornment='AED/Min'
        helperText={
          <span className='helperText'>Changes affect new top-ups only.</span>
        }
        value={state.minuteCost}
        onInputChanged={handleChange('minuteCost')}
      />

      <Box className={styles.Header}>
        <span className={styles.title}>Top-up Limits</span>
        <span className={styles.line}></span>
      </Box>

      <Box className={styles.section}>
        <ReskinningInputs
          labelValue='Minimum top-up limit'
          type='isnumber'
          withNumberPersantageFormat
          wrapperClasses={styles.wrapperInput}
          helperText={
            <span className='helperText'>
              Smallest amount agents can top up at once
            </span>
          }
          endAdornment='Minutes'
          value={state.minimumTopUp}
          onInputChanged={handleChange('minimumTopUp')}
        />
        <span className={styles.line}></span>
        <ReskinningInputs
          labelValue='Maximum top-up limit'
          type='isnumber'
          withNumberPersantageFormat
          wrapperClasses={clsx(styles.wrapperInput, styles.inputWithMargin)}
          helperText={
            <span className='helperText'>
              Largest amount agents can top up at once
            </span>
          }
          endAdornment='Minutes'
          value={state.maximumTopUp}
          onInputChanged={handleChange('maximumTopUp')}
        />
      </Box>

      <Box className={styles.Header}>
        <span className={styles.title}>Overdraft Management</span>
        <span className={styles.line}></span>
      </Box>

      <Box className={styles.filedContainer}>
        <Box className={styles.labelWrapper}>
          <div className={styles.label}>Enable/disable overdraft</div>
          <div className={styles.subLabel}>
            Allow agents to go into negative balance
          </div>
        </Box>
        <Box className={styles.filedWrapper}>
          <CustomSwitch
            size='md'
            label='Enable'
            checked={state.overdraftEnabled}
            onChange={(e) => {
              const isChecked = e.target.checked;
              setState((prev) => ({
                ...prev,
                overdraftEnabled: isChecked,
              }));
            }}
          />
          <ReskinningInputs
            labelValue='Overdraft limit'
            type='isnumber'
            withNumberPersantageFormat
            wrapperClasses={clsx(styles.Standard, styles.wrapperInput)}
            helperText={
              <span className='helperText'>
                Maximum negative balance allowed
              </span>
            }
            endAdornment='Minutes'
            value={state.overdraftMinutes}
            onInputChanged={handleChange('overdraftMinutes')}
          />
          <ReskinningInputs
            labelValue='Overdraft warning message'
            type='text'
            rows={4}
            multiline
            wrapperClasses={clsx(
              styles.Standard,
              styles.inputWithMargin,
              styles.wrapperInput
            )}
            value={state.overdraftWarningMessage}
            onInputChanged={handleChange('overdraftWarningMessage')}
          />
        </Box>
      </Box>

      <Box className={styles.Header}>
        <span className={styles.title}>Notification settings</span>
        <span className={styles.line}></span>
      </Box>

      <ReskinningInputs
        labelValue='Low balance threshold'
        type='isnumber'
        withNumberPersantageFormat
        wrapperClasses={styles.wrapperInput}
        helperText={
          <span className='helperText'>
            Notify agents when balance falls below this amount
          </span>
        }
        endAdornment='Minutes'
        value={state.lowBalanceThresholds}
        onInputChanged={handleChange('lowBalanceThresholds')}
      />
      <span className={styles.line}></span>
      <ReskinningInputs
        labelValue='Overdraft warning threshold'
        type='isnumber'
        withNumberPersantageFormat
        wrapperClasses={styles.wrapperInput}
        helperText={
          <span className='helperText'>
            Warn agents when approaching overdraft
          </span>
        }
        endAdornment='Minutes'
        value={state.overdraftWarningThresholds}
        onInputChanged={handleChange('overdraftWarningThresholds')}
      />
      <span className={styles.line}></span>
      <ReskinningInputs
        labelValue='Notification template editor'
        type='text'
        rows={4}
        multiline
        wrapperClasses={clsx(styles.wrapperInput, styles.inputWithMargin)}
        helperText={
          <span className='helperText'>
            Warn agents when approaching overdraft
          </span>
        }
        value={state.notificationTemplate}
        onInputChanged={handleChange('notificationTemplate')}
      />
    </Box>
  );
}
